export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-900"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20golden%20and%20amber%20lighting%2C%20soft%20film%20grain%20texture%2C%20subtle%20lens%20flare%2C%20dark%20theater%20atmosphere%20with%20elegant%20curved%20light%20streaks%20suggesting%20projection%20beams%2C%20minimalist%20cinematic%20aesthetic%2C%20no%20people%2C%20rich%20contrast%2C%20professional%20film%20studio%20vibe&width=1800&height=1000&seq=wuma-hero-2026&orientation=landscape"
          alt="午马影院 - 沉浸式观影体验"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-900/70 via-background-900/50 to-background-900/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-primary-500 whitespace-nowrap">
                热播推荐 · 每日更新
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-50 leading-tight mb-5">
              午马影院
              <span className="block text-primary-400 text-2xl md:text-3xl lg:text-4xl mt-2">
                电视剧大全 · 高清免费在线看
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-300 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              午马影院汇聚海量电视剧资源，囊括最新热播剧集与经典口碑作品，提供全集高清播放服务。无论是最新上线的国产剧、热播韩剧，还是经典美剧、日剧，均支持免费在线观看，画质清晰流畅不缓冲。平台实时同步更新，让你不错过任何一集精彩内容，追剧从未如此轻松。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">2000+</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">热门剧集覆盖</div>
              </div>
              <div className="w-px h-10 bg-foreground-500/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">同步追剧不等待</div>
              </div>
              <div className="w-px h-10 bg-foreground-500/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">高清不缓冲</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">流畅观影体验</div>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="px-7 py-3 text-sm md:text-base font-medium text-background-950 bg-primary-500 hover:bg-primary-400 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
              >
                <i className="ri-fire-fill mr-2"></i>
                查看热播榜单
              </a>
              <a
                href="#updates"
                className="px-7 py-3 text-sm md:text-base font-medium text-foreground-200 border border-foreground-300/30 hover:border-primary-500/50 hover:text-primary-400 rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-time-line mr-2"></i>
                最新更新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-background-950/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20abstract%20composition%20with%20floating%20film%20frames%20and%20soft%20glowing%20light%20orbs%2C%20warm%20amber%20and%20golden%20tones%2C%20depth-of-field%20blur%20effect%20on%20edges%2C%20elegant%20dark%20background%20with%20textured%20layers%2C%20modern%20streaming%20aesthetic%2C%20suggesting%20entertainment%20and%20cinema%20experience%2C%20no%20text%2C%20minimalist%20and%20artistic&width=1200&height=900&seq=wuma-hero-visual&orientation=landscape"
                alt="午马影院 - 电视剧大全高清在线播放"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex-1 bg-background-950/70 backdrop-blur-md rounded-xl px-4 py-3 border border-foreground-300/10">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                    <span className="text-xs text-foreground-200 whitespace-nowrap">正在热播</span>
                    <span className="text-xs text-primary-400 font-medium ml-auto whitespace-nowrap">更新至第28集</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}